import { render, staticRenderFns } from "./Lots.vue?vue&type=template&id=10942fc0&"
import script from "./Lots.vue?vue&type=script&lang=js&"
export * from "./Lots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports